// src/data/pllData.js
export const pllAlgorithms = [
  {
    id: 1,
    number: '01',
    name: 'Ua',
    image: require('@/pages/rubik/images/img125.png'),
    algorithm: `<span class="mainColor">M'2</span>U<span class="mainColor">M</span>U2<span class="mainColor">M'</span>U<span class="mainColor">M'2</span>`,
    alternativeAlgorithm: `(R<span class="mainColor2">U'</span>R)(UR)2(<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>R'2)`,
  },
  {
    id: 2,
    number: '02',
    name: 'Ub',
    image: require('@/pages/rubik/images/img131.png'),
    algorithm: `<span class="mainColor">M'2</span><span class="mainColor2">U'</span><span class="mainColor">M</span> U2<span class="mainColor">M'</span><span class="mainColor2">U'</span><span class="mainColor">M'2</span>`,
    alternativeAlgorithm:
      "(R2 U)(RU)(R'<span class=\"mainColor2\">U'</span>)2(R'UR')",
  },
  {
    id: 3,
    number: '03',
    name: 'H',
    image: require('@/pages/rubik/images/img136.png'),
    algorithm: `<span class="mainColor">M'2</span>U<span class="mainColor">M'2</span>U2<span class="mainColor">M'2</span>U<span class="mainColor">M'2</span>`,
  },
  {
    id: 4,
    number: '04',
    name: 'Z',
    image: require('@/pages/rubik/images/img120.png'),
    algorithm: `<span class="mainColor">M'</span>U(<span class="mainColor">M'2</span>U)2<span class="mainColor">M'</span>U2<span class="mainColor">M'2</span><span class="mainColor2">U'</span>`,
  },
  {
    id: 5,
    number: '05',
    name: 'Aa',
    image: require('@/pages/rubik/images/img126.png'),
    algorithm: `x'R2<span class="mainColor">D2</span>(R'<span class="mainColor2">U'</span>R)<span class="mainColor">D2</span>(R'UR')`,
  },
  {
    id: 6,
    number: '06',
    name: 'Ab',
    image: require('@/pages/rubik/images/img132.png'),
    algorithm: `x'(R<span class="mainColor2">U'</span>R)<span class="mainColor">D2</span>(R'UR)<span class="mainColor">D2</span>R'2`,
  },
  {
    id: 7,
    number: '07',
    name: 'E',
    image: require('@/pages/rubik/images/img137.png'),
    algorithm: `x'(R<span class="mainColor2">U'</span>R'<span class="mainColor">D</span>)(RUR'<span class="mainColor">D'</span>)(RUR'<span class="mainColor">D</span>)(R<span class="mainColor2">U'</span>R'<span class="mainColor">D'</span>)`,
  },
  {
    id: 8,
    number: '08',
    name: 'T',
    image: require('@/pages/rubik/images/img121.png'),
    algorithm: `[SX](R'F)(R2<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(RUR'<span class="mainColor3">F'</span>)`,
  },
  {
    id: 9,
    number: '09',
    name: 'F',
    image: require('@/pages/rubik/images/img127.png'),
    algorithm: `(R'<span class="mainColor2">U'</span><span class="mainColor3">F'</span>)<br/>[SX](R'F)(R2<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(RUR'UR)`,
  },
  {
    id: 10,
    number: '10',
    name: 'V',
    image: require('@/pages/rubik/images/img133.png'),
    algorithm: `(R'UR'd')(R'<span class="mainColor3">F'</span>R2<span class="mainColor2">U'</span>)(R'UR'FRF)`,
  },
  {
    id: 11,
    number: '11',
    name: 'Y',
    image: require('@/pages/rubik/images/img138.png'),
    algorithm: `F(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(RUR'<span class="mainColor3">F'</span>)[SX]<br/>[sh]`,
  },
  {
    id: 12,
    number: '12',
    name: 'Ja',
    image: require('@/pages/rubik/images/img122.png'),
    algorithm: `z(<span class="mainColor2">U'</span>R<span class="mainColor">D'</span>)(R2UR'<span class="mainColor2">U'</span>)(R2U)(<span class="mainColor">D</span>R')`,
    note: 'or 13 [left handed]',
  },
  {
    id: 13,
    number: '13',
    name: 'Jb',
    image: require('@/pages/rubik/images/img128.png'),
    algorithm: `(RUR'<span class="mainColor2">F'</span>)[SX](R'F)(R2<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)`,
  },
  {
    id: 14,
    number: '14',
    name: 'Rb',
    image: require('@/pages/rubik/images/img134.png'),
    algorithm: `(R'U2)(R<span class="mainColor3">U'</span><span class="mainColor2">U'</span>)(R'F) [SX](R'<span class="mainColor3">F'</span>R2<span class="mainColor2">U'</span>)`,
  },
  {
    id: 15,
    number: '15',
    name: 'Ra',
    image: require('@/pages/rubik/images/img139.png'),
    algorithm: `(R<span class="mainColor2">U'</span>R'<span class="mainColor2">U'</span>)(RUR<span class="mainColor">D</span>)(R'<span class="mainColor2">U'</span>R<span class="mainColor">D'</span>)(R'U2R'U')`,
  },
  {
    id: 16,
    number: '16',
    name: 'Gc',
    image: require('@/pages/rubik/images/img123.png'),
    algorithm: `(R'2<span class="mainColor2">u'</span>R<span class="mainColor3">U'</span>R)(UR'u)(R2fR'<span class="mainColor3">f'</span>)`,
  },
  {
    id: 17,
    number: '17',
    name: 'Gd',
    image: require('@/pages/rubik/images/img129.png'),
    algorithm: `(RUR')y'(R2<span class="mainColor3">u'</span>R<span class="mainColor2">U'</span>)(R'UR'uR2)`,
  },
  {
    id: 18,
    number: '18',
    name: 'Ga',
    image: require('@/pages/rubik/images/img135.png'),
    algorithm: `(R2uR')(UR'<span class="mainColor2">U'</span>R<span class="mainColor2">u'</span>)(R'2<span class="mainColor3">F'UF</span>)`,
  },
  {
    id: 19,
    number: '19',
    name: 'Gb',
    image: require('@/pages/rubik/images/img140.png'),
    algorithm: `(R'd'F)(R2u)(R'U)(R<span class="mainColor3">U'</span>R<span class="mainColor2">u'</span>R'2)`,
  },
  {
    id: 20,
    number: '20',
    name: 'Nb',
    image: require('@/pages/rubik/images/img124.png'),
    algorithm: `(R'UR<span class="mainColor2">U'</span>)(R'<span class="mainColor3">F'</span><span class="mainColor2">U'</span>)(FRUR'F)(R'<span class="mainColor3">F'</span>R<span class="mainColor2">U'</span>R)`,
  },
  {
    id: 21,
    number: '21',
    name: 'Na',
    image: require('@/pages/rubik/images/img130.png'),
    algorithm: `(RUR'<span class="mainColor">U</span>)(RUR'<span class="mainColor2">F'</span>)<br/>[SX](R'F)<br/>(R2<span class="mainColor2">U'</span>R'U2)(R<span class="mainColor2">U'</span>R')`,
  },
];

export const pllCategories = {
  adjacent: {
    label: 'Adjacent Swaps',
    items: [1, 2, 8, 9, 12, 13, 14, 15, 16, 17, 18, 19],
  },
  diagonal: { label: 'Diagonal Swaps', items: [5, 6, 10, 11, 20, 21] },
  edges: { label: 'Edge Permutations', items: [1, 2, 3, 4] },
  corners: { label: 'Corner Permutations', items: [5, 6, 7] },
  gPerms: { label: 'G Perms', items: [16, 17, 18, 19] },
  all: { label: 'Show All', items: 'all' },
};
